import { createAsyncThunk } from '@reduxjs/toolkit'
import MediaStatistic from './media-statistic-model'
import {
  delete_mediaStatistic,
  load_mediaStatistics,
  store_mediaStatistic,
} from './mediaStatistic-service'

export const LoadMediaStatisticsAsync = createAsyncThunk<any, any>(
  'composer/load/mediaStatistic',
  async (params: { uid: string }) => {
    return await load_mediaStatistics(params)
  },
)

export const CreateMediaStatisticAsync = createAsyncThunk<any, any>(
  'composer/create/mediaStatistic',
  async (params: MediaStatistic) => {
    return await store_mediaStatistic(params)
  },
)

export const DeleteMediaStatisticAsync = createAsyncThunk<any, any>(
  'composer/delete/mediaStatistic',
  async (params) => {
    return await delete_mediaStatistic(params)
  },
)
